/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useMemo } from 'react';
import InputDate from '../../../../../components/form/elements/date';
import { CalendarImage } from '../../../../../assets/icons/insex';
import { useTranslation } from 'react-i18next';
import Watch from '../../../../../components/form/elements/watch';
import moment from 'moment';

interface Props {
  rest: any;
  setDays: (value: number) => void;
  days: number;
}

function PeriodDates({ setDays, days, rest }: Props) {
  const { t } = useTranslation();

  const transKeyPrefix = 'pages.livestock.animals_and_events.';
  const tp = useCallback(
    (key: string, params?: { days: number }) =>
      t(transKeyPrefix.concat(key), params),
    [t]
  );

  const calculateDays = (getValues: any, setDays: (a: number) => void) => {
    const dateFrom: string = getValues('date_from');
    const dateTo: string = getValues('date_to');

    const fromDate = moment(dateFrom);
    const toDate = moment(dateTo);

    const days = toDate.diff(fromDate, 'days') + 1;

    if (new Date(dateFrom) <= new Date(dateTo)) {
      setDays(days);
    }
  };

  const DateFrom = useMemo(
    () =>
      Watch(
        InputDate(
          'date_from',
          null,
          null,
          null,
          true,
          CalendarImage,
          true,
          true
        ),
        ({ getValues }) => {
          calculateDays(getValues, setDays);
        }
      ),
    []
  );

  const DateTo = useMemo(
    () =>
      Watch(
        InputDate('date_to', null, null, null, true, CalendarImage, true, true),
        ({ getValues }) => {
          calculateDays(getValues, setDays);
        }
      ),
    []
  );

  return (
    <div>
      <div className="flex flex-row justify-between my-1">
        <label className="basis-1/2 text-[#6F6F6F]">
          {tp('events.grazing.periods')}{' '}
          <span className="text-[#12589F] font-bold">*</span>
        </label>
        <span className="basis-1/4 text-[#12589F] font-medium text-right">
          {' '}
          {tp('events.grazing.days', { days })}
        </span>
      </div>
      <div className="flex gap-1">
        <span className="flex-1">
          <DateFrom {...rest} />
        </span>
        <span className="flex-1">
          <DateTo {...rest} />
        </span>
      </div>
    </div>
  );
}

export default PeriodDates;
